<template>
  <div class="groupGoodList b_white">
    <div class="groupTabList b_white" v-if="isShow">
      <ul class="flex justify_around align_center">
        <li class="tabActive">进行中</li>
        <li>已结束</li>
      </ul>
    </div>

    <div class="groupList b_white" v-if="isEmptyGoods">
      <van-list
        :loading="loading"
        :finished="finished"
        :offset="20"
        :immediate-check="false"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div>
          <ul>
            <template v-for="(goods, index) in goodsList">
              <li class="clear" :key="index" v-if="goodsList"
                  @click="toDetail(goods.goodsId,goods.groupActivityId)">
                <div class="collect_img relative mui-pull-left">
                  <img v-lazy="`${goods.goodsEntity.picUrl}?imageMogr2/thumbnail/120000@`">
                </div>
                <div class="mui-media-body mui-pull-left collect_main">
                  <h3 class="f13_rem yahei gray_3 lin_15 box30 mui-ellipsis-2 ">
                    {{ goods.goodsEntity.name }}</h3>
                  <div class="box5"></div>
                  <p class="f10_rem gray_3">
                    {{goods.yxGroupActivityVo.startTimeStr.slice(0,10)}}
                    -
                    {{goods.yxGroupActivityVo.endTimeStr.slice(0,10)}}
                  </p>
                  <p class="lin_20">
                    <span class="red f14_rem">拼团价:¥{{goods.goodsPrice}}</span>
                  </p>
                  <p class="lin_15">
                    <span class="f10_rem gray_6">原价:¥{{goods.marketPrice}}</span>
                  </p>
                  <div class="collect_btn t_center white f12_rem">去拼团</div>
                </div>
              </li>
            </template>
          </ul>
        </div>
      </van-list>
    </div>
    <div class="exclusive_none" v-else>
      <img src="../images/search_none.png" alt="">
      <p class="gray_9">暂无商品</p>
    </div>
    <div class="group_me_float" @click="toMyGroup">
      <img src="../images/group_me.png" alt="">
      <span>我的拼团</span>
    </div>
    <!-- <div class="adv-mask hide" v-if="adv_pop"></div>
    <div class="adv-pop hide advIn" v-if="adv_pop">
      <a :href="addInfo.url">
        <img class="adv-img" :src="addInfo.img" alt="">
      </a>
      <img class="adv-close" src="https://filesouthcdn.nxin.com/nxsc_16190632938360921852599341694.png" alt="">
    </div> -->
    <!-- eslint-disable-next-line -->
    <van-popup v-model:show="showAdv" @click-overlay="adv_pop_close">
      <div>
        <a :href="addInfo.url">
          <img class="adv-img" :src="addInfo.img" alt="">
        </a>
      </div>
    </van-popup>
  </div>
</template>

<style lang="scss" scoped>
  @import './style.scss';
</style>

<script>
import jsonp from "jsonp";
import { mapState } from "vuex";
import common from "../../../assets/js/common";

export default {
  data() {
    return {
      isShow: false,
      isEmptyGoods: true,
      goodsList: [],
      pageNum: 1,
      finished: false,
      loading: false,
      refreshing: false,
      params: {},
      shopId: "",
      adv_pop: false,
      addInfo: {},
      showAdv: false
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {
    const { query } = this.$route;
    if (query.shopId) {
      this.shopId = query.shopId;
    }
    this.params = {
      pageNum: 1,
      pageSize: 8,
      shopId: query.shopId
    };
    this.onRefresh();
    this.adv_pop_open();
  },
  methods: {
    toMyGroup() {
      if (!common.isLogin(this.userInfo.id)) {
        return;
      }
      this.$router.push(`/group/myGroup?shopId=${this.shopId}`);
    },
    onLoad() {
      if (this.goodsList.length === 0) {
        return;
      }
      this.loading = true;
      this.pageNum += 1;
      const { params } = this;
      params.pageNum = this.pageNum;
      this.$store.dispatch("group/goods/queryGoodsList", params).then((res) => {
        if (res.data && res.data.length) {
          this.goodsList = [...this.goodsList, ...res.data];
          this.loading = false;
        } else {
          this.finished = true;
        }
      });
    },
    onRefresh() {
      const { params } = this;
      params.pageNum = 1;
      this.$store.dispatch("group/goods/queryGoodsList", params).then((res) => {
        if (res.data && res.data.length > 0) {
          this.goodsList = res.data;
        } else {
          this.isEmptyGoods = false;
          this.finished = true;
        }
      });
    },
    toDetail(id, activityId) {
      this.$router.push(`/group/groupBook/${id}/${activityId}?shopId=${this.shopId}`);
    },
    adv_pop_open() {
      // 请求是否弹窗的接口
      this.$store.dispatch("app/queryGuideShow", { ver: "1.0.3" }).then((data) => {
        if (data.code === 0 && data.data.showGuide) {
          const url = "https://graphicinformation.nxin.com/getJsonFormatAdList/260";
          jsonp(url, (err, res) => {
            // eslint-disable-next-line
            this.addInfo = res[0];
            this.showAdv = true;
          });
        }
      });
    },
    adv_pop_close() {
      this.$store.dispatch("app/queryGuiderecord", { ver: "1.0.3" }).then((res) => {
        console.log(res);
      });
    }
  }
};
</script>
